import React from 'react';
import PropTypes from 'prop-types';
import {
  withStyles,
  withMobileDialog,
} from '@material-ui/core';
import PageHeader from '../PageHeader';

import styles from './styles';

export class PageComponent extends React.Component {
  render() {
    const {
      title,
      hidePageHeader,
      children,
      toolbar,
      action,
      classes,
      showLoadingIndicator,
      disableToolbarGutters,
      disableToolbarPadding,
      fullScreen,
      hideMenuButton,
    } = this.props;

    return (
      <div className={classes.wrapper}>
        {
          !hidePageHeader
            && (
              <PageHeader
                title={title}
                action={action}
                showLoadingIndicator={showLoadingIndicator}
                disableBottomGutter={disableToolbarGutters}
                disablePadding={disableToolbarPadding}
                hideMenuButton={hideMenuButton}
              >
                {toolbar}
              </PageHeader>
            )
        }
        <div
          className={
            fullScreen
              ? classes.fullScreenBody
              : classes.body
          }
        >
          {children}
        </div>
      </div>
    );
  }
}

PageComponent.propTypes = {
  title: PropTypes.string,
  hidePageHeader: PropTypes.bool,
  children: PropTypes.any,
  toolbar: PropTypes.any,
  action: PropTypes.any,
  classes: PropTypes.object,
  showLoadingIndicator: PropTypes.bool,
  disableToolbarGutters: PropTypes.bool,
  disableToolbarPadding: PropTypes.bool,
  fullScreen: PropTypes.bool,
  hideMenuButton: PropTypes.bool,
};

PageComponent.defaultProps = {
  title: '',
  hidePageHeader: false,
  children: null,
  toolbar: null,
  action: null,
  classes: {},
  showLoadingIndicator: false,
  disableToolbarGutters: false,
  disableToolbarPadding: false,
  fullScreen: false,
  hideMenuButton: false,
};

export default withMobileDialog({ breakpoint: 'xs' })(withStyles(styles)(PageComponent));
